export enum StakingProgress {
  None = 0,
  Approving = 25,
  Approved = 50,
  Processing = 75,
  Done = 100,
}
